import { postPrayerSchema } from "../../../lib/types/schema/postPrayerSchema";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";

export const useRequestPostPrayer = () => {
  return {
    query: useRequestMutation<
      typeof postPrayerSchema,
      { type: "app-open" | "queue-completion" }
    >({
      mutationFnRequestProps: ({ type }) => ({
        method: "GET",
        urlBackendPath: `/me/postprayer/v3?type=${type}`,
        schema: postPrayerSchema,
      }),
    }),
  };
};
